module.exports = __webpack_public_path__ + "static/img/05.6ee7c90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-mb/story/05.png
// module id = ZE1l
// module chunks = 1